<template>
  <div class="icon" :style="style">{{fontCode}}</div>
</template>

<script>
  export default {
    name: 'houseIcon',
    props: {
      code: {
        type: String,
        required: true
      },
      size: {
        type: [Number, String],
        default: 32
      },
      color: String,
      fontFamily: {
        type: String,
        default: "zzIconfont"
      }
    },
    computed: {
      style() {
        return {
          fontFamily: this.fontFamily,
          fontSize: `${this.size}px`,
          color: this.color
        };
      },
      fontCode() {
        if (/&#x/.test(this.code)) {
          let _code = this.code.replace(/[&#x;]/g, "");
          return eval(`'\\u${_code}'`);
        } else if (/^\\u/.test(this.code)) {
          let _code = this.code.replace(/[\\u]/g, "");
          return eval(`'\\u${_code}'`);
        } else if (this.code.length > 1) {
          // return (Icon && Icon[this.code]) || "";
        }
        return this.code;
      }
    },
  }
</script>

<style>
  @font-face {
    font-family: zzIconfont;
    src: url('~@/assets/house/font/iconfont.ttf');
  }
</style>